import { FeatureFlagKey } from '@/app/core/models/feature-flag/featureFlagKey';
import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureFlagService } from '@services/feature-flag.service';
import { map, take } from 'rxjs/operators';

export const featureFlagGuard = (feature: FeatureFlagKey): CanMatchFn => {
	return () => {
		const featureFlagService = inject(FeatureFlagService);
		const router = inject(Router);

		return featureFlagService.getFeatureFlags().pipe(
			take(1),
			map(() => {
				const isEnabled = featureFlagService.isEnabled(feature);

				if (!isEnabled) {
					return router.createUrlTree(['/']);
				}
				return true;
			})
		);
	};
}
